import { createRouter, createWebHistory } from 'vue-router'
import HomeView from "@/views/HomeView"

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView,
    meta: {title: "Home"}
  },
  {
    path: '/register',
    name: 'Register',
    component: ()=> import('../views/RegisterView.vue'),
    meta: {title: "Buat Akun"}
  },
  {
    path: '/registration-process/:phoneNumber',
    name: 'RegistrationProcess',
    component: ()=> import('../views/RegistrationProcessView.vue'),
    meta: {title: "Proses Pendaftaran"}
  },
  {
    path: '/login',
    name: 'Login',
    component: ()=> import('../views/LoginView.vue'),
    meta: {title: "Login"}
  },
  {
    path: '/admin',
    name: 'Admin',
    component: ()=> import('../views/DashboardView.vue'),
    meta: {
      guard: true
    },
    children: [
      {
        path: "",
        name: "AdminHome",
        component: () => import("../views/AdminHomeView.vue"),
        meta: {
          title: "Dashboard",
          layout: {
            customMainContentsWrapper: true
          }
        }
      },
      {
        path: "account",
        name: "Account",
        component: () => import("../views/AccountView.vue"),
        meta: {title: "Akun"}
      },
      {
        path: "transaction/check",
        name: "TransactionCheck",
        component: () => import("../views/TransactionCheckView.vue"),
        meta: {title: "Cek Transaksi"}
      },
      {
        path: "transaction/history",
        name: "TransactionHistory",
        component: () => import("../views/TransactionHistoryView.vue"),
        meta: {title: "Riwayat Transaksi"}
      },
      {
        path: "transaction/summary",
        name: "TransactionSummary",
        component: () => import("../views/TransactionSummaryView.vue"),
        meta: {title: "Summary Transaksi"}
      },
      {
        path: "product/status",
        name: "ProductStatus",
        component: () => import("../views/ProductStatusView.vue"),
        meta: {title: "Status Produk"}
      },
      {
        path: "deposit-history",
        name: "DepositHistory",
        component: () => import("../views/DepositHistoryView.vue"),
        meta: {title: "Riwayat Deposit"}
      },
      {
        path: "balance-debit-credit",
        name: "BalanceDebitCredit",
        component: () => import("../views/BalanceDebitCreditView.vue"),
        meta: {title: "Balance Debit Credit"}
      },
      {
        path: "top-up",
        name: "TopUp",
        component: () => import("../views/TopUpView.vue"),
        meta: {title: "Top Up"}
      },
      {
        path: "log",
        name: "Log",
        component: () => import("../views/LogView.vue"),
        meta: {title: "Log"}
      },
      {
        path: "transfer",
        name: "Transfer",
        component: () => import("../views/TransferView.vue"),
        meta: {
          title: "Transfer",
          layout: {
            customMainContentsWrapper: true
          }
        }
      },
      {
        path: "transfer/spreadsheet",
        name: "TransferSpreadsheet",
        component: () => import("../views/TransferSpreadsheetView.vue"),
        meta: {
          title: "Transfer",
          layout: {
            customMainContentsWrapper: true
          }
        }
      },
      {
        path: "transfer/manual-input",
        name: "TransferManualInput",
        component: () => import("../views/TransferManualInputView.vue"),
        meta: {
          title: "Transfer",
          layout: {
            customMainContentsWrapper: true
          }
        }
      },
      {
        path: "transfer/payment",
        name: "TransferPayment",
        component: () => import("../views/TransferPaymentView.vue"),
        meta: {
          title: "Transfer",
          layout: {
            customMainContentsWrapper: true
          }
        }
      },
      {
        path: "transfer/send",
        name: "TransferSend",
        component: () => import("../views/TransferSendView.vue"),
        meta: {
          title: "Transfer",
          layout: {
            customMainContentsWrapper: true
          }
        }
      }
    ]
  },
  {
    path: '/contact-us',
    name: 'ContactUs',
    component: ()=> import('../views/ContactUsView.vue'),
    meta: {title: "Hubungi Kami"}
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
